import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { first, Observable } from 'rxjs';
import { ConfigService } from 'src/app/services/config-service/config.service';

@Component({
  selector: 'app-link-expired',
  templateUrl: './link-expired.component.html',
  styleUrls: ['./link-expired.component.scss'],
})
export class LinkExpiredComponent implements OnInit {
  frmLink = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(
        '[a-zA-Z0-9._-]{3,}@[a-zA-Z0-9.-]{3,}[.][a-zA-Z]{2,4}'
      ),
    ]),
  });

  private config;

  constructor(
    private messageService: MessageService,
    private httpClient: HttpClient
  ) {
    const strConfig = localStorage.getItem('config-service');
    if (strConfig) {
      this.config = JSON.parse(strConfig);
    }
  }

  ngOnInit(): void {}

  resendLink() {
    const params = new HttpParams()
      .set('email', this.frmLink.value.email)
      .set('baseURL', window.location.origin);

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    const submission$: Observable<any> = this.httpClient.post(
      this.config.firstTimeUserURL,
      null,
      { headers: headers, params: params }
    );
    submission$.pipe(first()).subscribe({
      next: (response: any) => {
        if (response.first_time)
          this.messageService.add({
            key: 'toast',
            severity: 'info',
            life: 5000,
            detail: 'Sent! Didn’t get an email? Contact your account manager.',
          });
        else
          this.messageService.add({
            key: 'toast',
            severity: 'error',
            life: 5000,
            detail: 'Invalid Email.',
          });
      },
      error: (error: any) => {
        console.error(error);
      },
    });
  }
}
